export default __webpack_public_path__ + "static/nhs-england-4201286b20194e9fb0cbd3eda82e5c5d.png";